export default __webpack_public_path__ + "static/media/Livingroom-Interior-Architecture-EschweilerPhotography_21A0021-HDR Kopie.eafec5ea.jpg";